import {
  RefundDestinationEnum,
  RequestAccidents,
  RiskPrime,
  StaffOrderAccidents
} from '@insurance/api/requests'
import { UploadChangeParam, UploadFile } from 'antd/es/upload'

import { Contractor, Person } from '../PersonsFields'

export enum ContractTypeCode {
  FAMILIAL = 'familial',
  INDIVIDUAL = 'individual',
  COLLECTIVE = 'collective'
}

export enum TerritoryCode {
  NATIONAL = 'national',
  INTERNATIONAL = 'international'
}

export enum SportsCode {
  NO_RISK = 'no_risk',
  MEDIUM_RISK = 'medium_risk',
  HIGH_RISK = 'high_risk'
}

export enum ProfessionalCode {
  LOW_RISK = 'low_risk',
  MEDIUM_RISK = 'medium_risk',
  HIGH_RISK = 'high_risk',
  SPECIAL_RISK = 'special_risk'
}

export type AccidentFormValues = {
  order_price?: { amount?: string; currency?: string }
  price?: { amount?: string; currency?: string }
  step: number
  prev_step?: number
  count_days: number
  same_contractor_as_first_person: boolean
  persons: Person[]
  contractor: Contractor
  customer: StaffOrderAccidents['customer']
  __risks?: RiskPrime[]
  ancillary_risks?: RiskPrime[]
  persons_str?: UploadChangeParam<UploadFile>
  effective_date?: string
  refund_destination?: RefundDestinationEnum
  credit?: number
} & Omit<RequestAccidents, 'session' | 'persons' | 'contractor' | 'persons_str'>
